import React, { useRef, useState } from "react";
import { IconButton, TextField } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import { isValidExpextedRaceTime } from "./utils";
import useDidMountEffect from "../../../Common/UseDidMountEffect";

type Props = {
    label: string;
    defaultValue?: string;
    onChange: (value: string) => void;
};

const ExpectedRaceTimeField = (props: Props) => {
    const [value, setValue] = useState<string>(props.defaultValue ?? "");
    const [hasErrors, setHasErrors] = useState(false);

    const inputRef = useRef<HTMLInputElement>();

    useDidMountEffect(() => {
        const { onChange } = props;

        onChange(value);
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
        setHasErrors(false);
    };

    const handleBlur = () => {
        let isValid = true;

        if (!value && inputRef?.current) {
            isValid = inputRef.current.checkValidity();
        }

        setHasErrors(!isValid);
    };

    const handleClear = () => {
        setValue("");
    };

    const render = () => {
        const { label } = props;

        const hasValidValue = isValidExpextedRaceTime(value);

        if (!hasValidValue) {
            return (
                <TextField
                    id="time"
                    fullWidth
                    value={value ?? ""}
                    label={label}
                    disabled
                    InputLabelProps={{ shrink: true }}
                    error={true}
                    helperText="Felaktigt format"
                    InputProps={{
                        endAdornment:
                            (<IconButton
                                style={{ padding: 0 }}
                                onClick={handleClear}>
                                <ClearIcon />
                            </IconButton>)
                    }}
                />
            );
        }

        return (
            <TextField
                id="time"
                fullWidth
                type="time"
                value={value ?? ""}
                label={label}
                InputLabelProps={{ shrink: true }}
                inputProps={{ ref: inputRef }}
                error={hasErrors}
                helperText={hasErrors ? "Felaktigt ifyllt värde" : ""}
                onChange={handleChange}
                onBlur={handleBlur}
            />
        );
    };

    return render();
};

export default ExpectedRaceTimeField;
